import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmCustomIssueRoute: InvariantJiraRoute = {
	name: 'csm-queues-custom-issue-detail',
	path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId/:issueKey',
	exact: true,
};
